import { t } from "@/plugins/i18n/i18n"

export const WARNING_THRESHOLD = 50
export const MAX_CONSECUTIVE_ERRORS = 3
const USER_TYPE = {
  guest: "guest",
  known: "other",
}

const getUserTranslationParams = (
  firstName: string,
  extraParams: Record<string, string | number> = {}
) => {
  // Fallback in case of unknown user firstname
  const name = firstName?.trim()

  return name
    ? { user: USER_TYPE.known, first_name: name, ...extraParams }
    : { user: USER_TYPE.guest, ...extraParams }
}

export const AGENT_MESSAGES = {
  greeting: (first_name: string, job_name: string) =>
    job_name
      ? t(
          "scan.writing.intro_question",
          getUserTranslationParams(first_name, { job_name })
        )
      : t(
          "scan.writing.intro_question_no_job",
          getUserTranslationParams(first_name)
        ),
  nearingEnd: (remaining: number) =>
    t("scan.writing.limit.warning", { remaining }),
  reconnect: (first_name: string) =>
    t("scan.writing.resume.welcome_back", getUserTranslationParams(first_name)),
  error: () => t("scan.writing.error.refresh.segment_1"),
  redirect: (seconds: number) => t("scan.writing.end.redirect", { seconds }),
  maxReached: () => t("scan.writing.limit.reached"),
}
